const CONTENT = {
  shipping: {
    title: "Shipping Policy",
    subtitle: "Processing times, delivery windows and customs.",
    sections: [
      ["Processing", "Orders are processed within 1–2 business days from our Johannesburg studio. Orders placed on weekends or public holidays are processed the next business day."],
      ["Domestic Shipping (South Africa)", "Standard delivery 3–5 business days · R 150 (free over R 2 000). Express delivery 1–2 business days · R 350. Couriers: Aramex, The Courier Guy, RAM."],
      ["International Shipping", "We ship globally via DHL Express. Estimated delivery 7–14 business days. Rates are calculated at checkout and may exclude duties and import taxes payable on arrival."],
      ["Tracking", "Once your order ships, a tracking link is emailed to you and is also available via the Track Order page."],
      ["Lost or Delayed Parcels", "If your tracking shows no movement for more than 5 business days, contact hello@maisonluxe.co.za and we'll investigate with the courier."],
      ["Customs", "International customers are responsible for any applicable duties or VAT on import. Maison Luxe is not liable for parcels held by customs authorities."],
    ],
  },
  refund: {
    title: "Refund & Returns Policy",
    subtitle: "Eligibility, process and timelines.",
    sections: [
      ["Eligibility", "Uncut, unworn lace wigs with the original tags, plastic and packaging intact may be returned within 30 days of delivery."],
      ["Not eligible", "Wigs whose lace has been cut, tinted, bleached, dyed or otherwise altered. Headband wigs and clip-ins for hygiene reasons. Sale items are final."],
      ["Damaged or Incorrect Items", "If your wig arrived damaged or you received the wrong item, email hello@maisonluxe.co.za within 48 hours of delivery with photos. We'll arrange replacement or refund at no cost to you."],
      ["How to Return", "1. Email hello@maisonluxe.co.za with your order number. 2. We'll send a return authorisation and arrange courier collection (Gauteng & WC) or you'll receive prepaid label (other provinces). 3. Once we receive and inspect the wig, refund is processed within 5 business days."],
      ["Refund Timelines", "Approved refunds are processed within 5 business days to your original payment method. Bank/instant EFT refunds may take an extra 2–4 business days to reflect."],
      ["Exchanges", "Want a different length, density or texture? We process exchanges as quickly as returns. Pay any difference at the time of exchange request."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    subtitle: "How we handle your data.",
    sections: [
      ["Information We Collect", "Name, email, shipping address, billing address, phone, order history and (when subscribed) your newsletter email."],
      ["How We Use It", "To fulfil orders, communicate updates, process refunds, send (only if you opt in) marketing communications, and prevent fraud."],
      ["Payment Data", "All card details are processed by Yoco, PayFast and Ozow on their PCI-DSS Level 1 infrastructure. Maison Luxe never stores your card details."],
      ["Sharing", "We share data only with: couriers (to fulfil shipping), payment gateways, and email service providers required to operate the store. We never sell your data."],
      ["Cookies", "We use cookies for cart functionality, anonymous analytics and to remember your session. You can disable cookies in your browser at any time."],
      ["Your Rights (POPIA)", "Under POPIA you may request access to, correction of, or deletion of your personal information. Email privacy@maisonluxe.co.za."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    subtitle: "The fine print.",
    sections: [
      ["Agreement", "By placing an order with Maison Luxe (Pty) Ltd you agree to these terms and conditions. Trading as Maison Luxe, South Africa."],
      ["Pricing", "All prices are in South African Rand (ZAR / R) and include 15% VAT where applicable. Prices may change without notice but the price at the time of your confirmed order will be honoured."],
      ["Product Information", "We make every effort to display product colours accurately. Slight variations may occur due to monitor settings, lighting and natural fibre variation."],
      ["Liability", "Our liability is limited to the value of the product purchased. We do not accept liability for indirect or consequential damages."],
      ["Governing Law", "These terms are governed by the laws of the Republic of South Africa."],
    ],
  },
};

export default function PolicyPage({ kind }) {
  const data = CONTENT[kind];
  if (!data) return null;
  return (
    <div data-testid={`policy-${kind}-page`} className="max-w-3xl mx-auto px-6 py-20">
      <p className="small-label">Policy</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">{data.title}</h1>
      <p className="text-stone mt-3">{data.subtitle}</p>
      <div className="mt-12 space-y-10">
        {data.sections.map(([t, b], i) => (
          <section key={i}>
            <p className="font-serif text-xl">{t}</p>
            <p className="text-stone mt-2 leading-relaxed whitespace-pre-line">{b}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
